import { Badge, CloseButton } from "@mantine/core"

export type FilterChipData = {
  key: string
  label: string
  value: string
  onRemove: () => void
}

type Props = FilterChipData

export function FilterChip({ label, value, onRemove }: Props) {
  return (
    <Badge
      size="lg"
      radius="sm"
      variant="light"
      color="brand"
      rightSection={<CloseButton size="xs" variant="transparent" onClick={onRemove} />}
      styles={{
        root: { textTransform: "none", fontWeight: 500, paddingRight: 4 },
        label: { overflow: "visible" },
      }}
    >
      {label}: {value}
    </Badge>
  )
}
